// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1PeM-","label":"Category_label__197wo","content":"Category_content__39f7b","header":"Category_header__2xgE4","location":"Category_location__u9UVR"};